import { Loader2, Sparkles } from "lucide-react";
import Markdown from "react-markdown";
import type { AiChatMessage } from "./ai-chat-model";

export function AiChatUserMessage({ text }: { text: string }) {
  return (
    <div className="flex justify-end">
      <div className="w-fit max-w-[85%] whitespace-pre-line break-words rounded-full bg-text-primary px-4 py-2 font-body text-body-2 text-white">
        {text}
      </div>
    </div>
  );
}

export function AiChatAssistantMessage({
  text,
  pending = false,
}: {
  text: string;
  pending?: boolean;
}) {
  return (
    <div className="flex items-start gap-2">
      <Sparkles
        className="mt-1 size-3.5 shrink-0 text-icon-tertiary"
        aria-hidden
      />
      <div className="min-w-0 flex-1 rounded-2xl border border-surfaces-divider bg-white p-4">
        {pending && text.length === 0 ? (
          <span className="inline-flex items-center gap-2 font-body text-body-2 text-text-tertiary">
            <Loader2 className="size-4 animate-spin" aria-hidden />
            Thinking…
          </span>
        ) : (
          <div className="prose prose-sm max-w-none font-body text-body-2 text-text-secondary prose-headings:text-text-primary prose-p:my-0 prose-p:leading-relaxed prose-strong:text-text-primary prose-ul:my-1 [&_p+p]:mt-3">
            <Markdown>{text}</Markdown>
          </div>
        )}
      </div>
    </div>
  );
}

export function AiChatMessageRow({ message }: { message: AiChatMessage }) {
  return message.role === "user" ? (
    <AiChatUserMessage text={message.text} />
  ) : (
    <AiChatAssistantMessage text={message.text} />
  );
}
